/**
 * Slug rules. A slug is the whole public identity of a profile
 * (ugc.lalohq.com/{slug}) and shares the URL namespace with the app's own
 * routes, so anything the SPA or CloudFront needs is reserved.
 */
export const SLUG_MIN_LENGTH = 3;
export const SLUG_MAX_LENGTH = 30;
/** Lowercase alphanumerics and single inner hyphens. */
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
/**
 * Paths the SPA, the CDN or a future feature already owns. Kept deliberately
 * broad — freeing a reserved word later is easy, reclaiming a taken one is not.
 */
export const RESERVED_SLUGS = new Set([
    // infrastructure + app routes
    'api', 'media', 'app', 'admin', 'assets', 'static', 'public', 'cdn', 'config',
    'login', 'logout', 'signup', 'signin', 'signout', 'register', 'verify',
    'confirm', 'forgot-password', 'reset-password', 'account', 'settings',
    'dashboard', 'editor', 'profile', 'profiles', 'me', 'user', 'users',
    // marketing + legal
    'about', 'pricing', 'terms', 'privacy', 'legal', 'support', 'help', 'contact',
    'docs', 'blog', 'faq', 'home', 'index', 'explore', 'discover', 'search',
    // operational
    'health', 'healthz', 'status', 'robots', 'sitemap', 'favicon', 'well-known',
    'null', 'undefined', 'true', 'false', 'new', 'edit', 'delete', 'test',
]);
/** Normalise arbitrary text into a candidate slug (used by the signup helper). */
export function slugify(input) {
    return input
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-{2,}/g, '-')
        .slice(0, SLUG_MAX_LENGTH)
        .replace(/-+$/, '');
}
/** Returns null when the slug is structurally usable, else why it is not. */
export function validateSlug(slug) {
    if (slug.length < SLUG_MIN_LENGTH ||
        slug.length > SLUG_MAX_LENGTH ||
        !SLUG_PATTERN.test(slug)) {
        return 'invalid';
    }
    if (RESERVED_SLUGS.has(slug))
        return 'reserved';
    return null;
}
//# sourceMappingURL=slug.js.map